export const cartData = [
  {
    item: {
      janCode: "4550344949986",
      amount: 1,
      salesPrice: 1490,
      originalPrice: 1490,
      summary: {
        damImage:
          "https://www.muji.com/public/media/img/item/4550344949986_400.jpg",
        itemName: "軽量　晴雨兼用　折りたたみ傘５０ｃｍ・５本骨・黒チェック",
        skuName: "軽量　晴雨兼用　折りたたみ傘",
        itemStandardName: "５０ｃｍ・５本骨・黒チェック",
        materialName: "軽量",
        colorLabel: "黒チェック",
        sizeLabel: "傘５０ｃｍ",
        shopReceive: true,
        otherStoreReceive: true,
        serviceWorks: [],
        privateWorks: [
          {
            workCode: "100",
            workName: "ギフト",
            price: 0,
            priceNoTax: 0,
            privateWorkDivision: "GIFT_MESSAGE",
            privateWorksDefaultCheckFlag: false,
          },
          {
            workCode: "101",
            workName: "ギフト箱",
            price: 160,
            priceNoTax: 146,
            privateWorkDivision: "GIFT_BOX",
            privateWorksDefaultCheckFlag: false,
          },
          {
            workCode: "803",
            workName: "のし",
            price: 0,
            priceNoTax: 0,
            privateWorkDivision: "NOSHI",
            privateWorksDefaultCheckFlag: false,
          },
        ],
        itemClass: "178",
        salesLimitQuantity: 20,
        docomoPayment: true,
        stock: {
          status: "FEWNESS",
          quantity: 1,
        },
        priceKindList: [],
        deliveryPrice: {
          itemDivision: "A",
          deliveryFree: true,
        },
        price: {
          basicPrice: 1490,
          basicPriceNoTax: 1355,
        },
        orderStyle: "なし",
        orderFont: "なし",
        orderItemFlag: false,
        itemSection: "001",
        deliveryDivision: "TH",
        storeJanCode: "44949986",
        refundEnableDays: 30,
      },
      index: 0,
    },
    hemmingSettingList: [],
    isLoggedIn: false,
    deliverySystemFlg: false,
    orders: [],
  },
  {
    item: {
      janCode: "4547315172948",
      amount: 1,
      salesPrice: 5990,
      originalPrice: 5990,
      summary: {
        damImage:
          "https://www.muji.com/public/media/img/item/4547315172948_400.jpg",
        itemName: "風を通すＴシャツ男女兼用Ｌ～ＸＬ・ベージュ",
        skuName: "風を通すＴシャツ",
        itemStandardName: "男女兼用Ｌ～ＸＬ・ベージュ",
        materialName: "",
        colorLabel: "ベージュ",
        sizeLabel: "Ｌ～ＸＬ",
        shopReceive: true,
        otherStoreReceive: true,
        serviceWorks: [],
        privateWorks: [
          {
            workCode: "100",
            workName: "ギフト",
            price: 0,
            priceNoTax: 0,
            privateWorkDivision: "GIFT_MESSAGE",
            privateWorksDefaultCheckFlag: false,
          },
          {
            workCode: "101",
            workName: "ギフト箱",
            price: 160,
            priceNoTax: 146,
            privateWorkDivision: "GIFT_BOX",
            privateWorksDefaultCheckFlag: false,
          },
          {
            workCode: "803",
            workName: "のし",
            price: 0,
            priceNoTax: 0,
            privateWorkDivision: "NOSHI",
            privateWorksDefaultCheckFlag: false,
          },
        ],
        itemClass: "332",
        salesLimitQuantity: 20,
        docomoPayment: true,
        stock: {
          status: "STOCK",
          quantity: 25,
        },
        priceKindList: [],
        deliveryPrice: {
          itemDivision: "A",
          deliveryFree: true,
        },
        price: {
          basicPrice: 5990,
          basicPriceNoTax: 5446,
        },
        orderStyle: "なし",
        orderFont: "なし",
        orderItemFlag: false,
        itemSection: "001",
        deliveryDivision: "TH",
        storeJanCode: "15172948",
        refundEnableDays: 30,
      },
      index: 1,
    },
    hemmingSettingList: [],
    isLoggedIn: false,
    deliverySystemFlg: false,
    orders: [],
  },
];
